import { render, staticRenderFns } from "./Directory.vue?vue&type=template&id=81623a3a&scoped=true&"
import script from "./Directory.vue?vue&type=script&lang=js&"
export * from "./Directory.vue?vue&type=script&lang=js&"
import style0 from "./Directory.vue?vue&type=style&index=0&id=81623a3a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81623a3a",
  null
  
)

export default component.exports